import React from 'react';
import { useTranslation } from 'react-i18next';

function HelpPanel({ open, field, onClose, contentType }) {
  const { t } = useTranslation();

  if (!open) {
    return null;
  }

  const renderContent = () => {
    switch (field) {
      case 'structureAttendue':
        {
          const raw = (contentType || '').toString().toLowerCase();

          const isProduct =
            raw.includes('fiche produit') || raw.includes('product') || raw.includes('produit');
          const isCategory =
            raw.includes('page catégorie') ||
            raw.includes('page categorie') ||
            raw.includes('catégorie') ||
            raw.includes('categorie') ||
            raw.includes('category page') ||
            raw.includes('long_category') ||
            raw.includes('long category');
          const isStoreLocator =
            raw.includes('store locator') || raw.includes('magasin') || raw.includes('store_locator');
          const isGmb = raw === 'gmb' || raw.includes('google my business');

          const headerLabel = isCategory
            ? t('Page catégorie')
            : isGmb
              ? 'GMB'
              : isStoreLocator
                ? t('Store locator')
                : t('Page produit');

          const rows = isCategory
            ? [
              { k: 'H1', v: t('Nom de la catégorie – Notre sélection de mot-clé principal') },
              { k: 'H2', v: t('Présentation de la catégorie') },
              { k: 'H2', v: t('Découvrez nos différents types de produits ou services') },
              { k: 'H3', v: t('Sous-catégorie 1') },
              { k: 'H3', v: t('Sous-catégorie 2') },
              { k: 'H2', v: t("Guide d’achat – Comment bien choisir ?") },
              { k: 'H2', v: t('Pourquoi faire confiance à la marque ?') },
            ]
            : isGmb
              ? [
                { k: 'Titre', v: t('Titre avec Nom établissement  + catégorie') },
                { k: 'Adresse & contact', v: t('Adresse & contact : Une phrase simple avec adresse et numéro de téléphone') },
                { k: 'Description courte', v: t('Description courte (accroche impactante, bénéfices immédiats)') },
                { k: 'Description moyenne', v: t('Description moyenne (structurée, orientée bénéfices, solutions pour le client)') },
                { k: 'Produits phares', v: t('Produits phares (liste)') },
                { k: 'Horaires', v: t('Horaires') },
              ]
              : isStoreLocator
                ? [
                  { k: 'H1', v: t('Trouver un magasin Nom de l’enseigne') },
                  { k: 'H2', v: t('Notre réseau de magasins') },
                  { k: 'H2', v: t('Comment trouver le magasin le plus proche ?') },
                  { k: 'H2', v: t('Nos implantations par région') },
                  { k: 'H3', v: t('Région 1') },
                  { k: 'H3', v: t('Région 2') },
                  { k: 'H2', v: t('Services disponibles en magasin') },
                  { k: 'H2', v: t('Préparer votre visite') },
                  { k: 'H2', v: t('Questions fréquentes sur nos magasins') },
                ]
                : [
                  { k: 'H1', v: t('Nom du produit + bénéfice principal') },
                  { k: 'H2', v: t('Présentation du produit') },
                  { k: 'H2', v: t('Caractéristiques et détails techniques') },
                  { k: t('Liste'), v: t('Points clés ou caractéristiques') },
                  { k: 'H2', v: t("Avantages pour l'utilisateur") },
                  { k: 'H2', v: t('Pourquoi choisir ce produit ?') },
                  { k: 'H2', v: t("À qui s'adresse ce produit ?") },
                  { k: 'H2', v: t("Conseils d'utilisation") },
                  { k: 'H2', v: t('Questions fréquentes') },
                ];

          return (
            <>
              <h5 className="help-panel-section-title">{t('Structure attendue')}</h5>
              <p style={{ backgroundColor: '#F1F1F1', color: '#818181', padding: '8px', borderRadius: '8px' }}>
                {t("🎯 Ce champ permet de définir l'organisation du contenu généré. Il indique les sections et sous-sections que l'IA doit respecter lors de la rédaction.")}
              </p>

              <div
                style={{
                  marginTop: '16px',
                  borderRadius: '12px',
                  border: '1px solid #E5E7EB',
                  overflow: 'hidden',
                  backgroundColor: '#F1F1F1',
                }}
              >
                <div
                  style={{
                    padding: '10px 14px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '8px',
                  }}
                >
                  <img
                    src="/Images/product-icon.png"
                    alt=""
                    className="help-panel-product-icon"
                    style={{ width: '24px', height: '24px', flexShrink: 0 }}
                  />
                  <div style={{ fontSize: '13px', fontWeight: 600 }}>{headerLabel}</div>
                </div>

                <div
                  style={{
                    padding: '10px 14px',
                    borderTop: '2px solid #EEEEEE',
                    backgroundColor: '#FDFDFC',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px',
                    borderRadius: '18px 18px 0 0',
                  }}
                >
                  <div style={{ fontSize: '13px', fontWeight: 600 }}>{t('Format recommandé')}</div>
                  <div style={{ fontSize: '12px', color: '#6B7280' }}>
                    {t('→ Utilisez une structure hiérarchique claire')}
                  </div>
                </div>

                <div
                  style={{
                    padding: '10px 14px',
                    fontSize: '12px',
                    color: '#374151',
                    borderTop: '1px solid #EEEEEE',
                    backgroundColor: '#FDFDFC',
                  }}
                >
                  {rows.map((row, idx) => (
                    <div className="help-panel-table-row" key={`${row.k}-${idx}`}>
                      <div className="help-panel-table-label">{row.k}</div>
                      <div className="help-panel-table-value">{row.v}</div>
                    </div>
                  ))}
                </div>
              </div>

              <div
                style={{
                  padding: '6px 0 0',
                  fontSize: '11px',
                  color: '#9CA3AF',
                }}
              >
                {t('Vous pouvez vous inspirer de cet exemple pour structurer votre champ.')}
              </div>
            </>
          );
        }
      case 'baseConnaissanceEnLigne':
        return (
          <>
            <h5 className="help-panel-section-title">{t('Base de connaissance en ligne')}</h5>
            <p
              style={{
                backgroundColor: '#F1F1F1',
                color: '#818181',
                padding: '8px 8px 8px 36px',
                borderRadius: '8px',
                position: 'relative',
                marginBottom: '12px',
              }}
            >
              {t("🎯 Ce champ permet d'indiquer les pages web sur lesquelles l'IA peut s'appuyer pour enrichir ses réponses.")}
            </p>

           

            <div
              style={{
                marginTop: '16px',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
              }}
            >
              <div
                style={{
                  padding: '10px 14px',
                  borderBottom: '1px solid #E5E7EB',
                  backgroundColor: '#F9FAFB',
                }}
              >
                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                  {t('Format recommandé')}
                </div>
                <div style={{ fontSize: '12px', color: '#6B7280' }}>
                  {t("→ Liste d'URL séparées par une virgule ou un retour à la ligne.")}
                </div>
              </div>
              <div
                style={{
                  padding: '10px 14px',
                  fontSize: '12px',
                  color: '#374151',
                }}
              >
                <div style={{ color: '#6B7280', lineHeight: 1.8 }}>
                  https://www.exemple.com/faq<br />
                  https://www.exemple.com/conditions-generales<br />
                  https://www.exemple.com/guide-utilisation
                </div>
              </div>
            </div>
          </>
        );
      case 'recommandedLexique':
        return (
          <>
            <h5 className="help-panel-section-title">{t('Bonnes pratiques pour le lexique recommandé')}</h5>
            <p
              style={{
                backgroundColor: '#F1F1F1',
                color: '#818181',
                padding: '8px 8px 8px 36px',
                borderRadius: '8px',
                position: 'relative',
                marginBottom: '12px',
              }}
            >
     
              {t("🎯 Le champ lexical permet d'indiquer des termes à privilégier afin d'enrichir le vocabulaire et renforcer la cohérence thématique du contenu. ")}
            </p>

            

            
            <div
              style={{
                marginTop: '16px',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
              }}
            >
              <div
                style={{
                  padding: '10px 14px',
                  borderBottom: '1px solid #E5E7EB',
                  backgroundColor: '#F9FAFB',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                  {t('Format recommandé')}
                </div>
                <div style={{ fontSize: '12px', color: '#6B7280' }}>
                  {t("→ Ajouter une liste de mots ou d'expressions liés au sujet.")}
                </div>
              </div>
              <div
                style={{
                  padding: '10px 14px',
                  borderTop: '1px solid #E5E7EB',
                  fontSize: '12px',
                  color: '#374151',
                }}
              >
               
                <div style={{ color: '#6B7280', lineHeight: 1.8 }}>
                {t('Expérience Immersive')}<br />
                  {t('Émotion')}<br />
                  {t('Mise en scène')}<br />
                  {t('Artiste')}<br />
                  {t('Performance')}<br /> 
                  {t('Billetterie')}<br />
                  {t('Programmation')}<br />
                  {t('Ambiance')}
                </div>
              </div>
            </div>

            <div
              style={{
                padding: '6px 0 0',
                fontSize: '11px',
                color: '#9CA3AF',
              }}
            >
              {t('Vous pouvez vous inspirer de cet exemple pour structurer votre champ.')}
            </div>
          </>
        );
      case 'instructionsPersonnalisation':
        return (
          <>
            <h5 className="help-panel-section-title">
              {t('Comment utiliser les consignes complémentaires')}
            </h5>
            <p
              style={{
                backgroundColor: '#F1F1F1',
                color: '#818181',
                padding: '8px 8px 8px 12px',
                borderRadius: '8px',
                marginBottom: '12px',
              }}
            >
              {t("🎯 Les consignes complémentaires permettent d’ajouter des précisions spécifiques au contenu généré. Elles servent à orienter la génération sur un point particulier sans modifier la structure ou les règles principales définies par l’agent.")}
            </p>

            

            <div
              style={{
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
              }}
            >
              <div
                style={{
                  padding: '10px 14px',
                  borderBottom: '1px solid #E5E7EB',
                  backgroundColor: '#F9FAFB',
                }}
              >
                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                  {t('Exemple de consignes complémentaires')}
                </div>
              </div>

              <div style={{ padding: '10px 14px', fontSize: '12px', color: '#374151' }}>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t("Angle à privilégier")}
                  </div>
                  <div className="help-panel-table-value">
                    {t("Mettre l'accent sur l'aspect écologique")}
                  </div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Point à approfondir')}
                  </div>
                  <div className="help-panel-table-value">
                    {t("Inclure un exemple concret d'utilisation")}
                  </div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t("Élément à inclure")}
                  </div>
                  <div className="help-panel-table-value">
                    {t("Valoriser l’impact pour les familles")}
                  </div>
                </div>
              </div>

            </div>

            <div
              style={{
                padding: '6px 0 0',
                fontSize: '11px',
                color: '#9CA3AF',
              }}
            >
              {t('Ces consignes s’appliquent à chaque texte généré par cet agent.')}
            </div>
          </>
        );
      case 'redactionRules':
        return (
          <>
            <h5 className="help-panel-section-title">{t('Règles rédactionnelles')}</h5>
            <p style={{ backgroundColor: '#F1F1F1', color: '#818181', padding: '8px', borderRadius: '8px' }}>
              {t("🎯 Ce champ définit uniquement le style d'écriture. Il ne modifie pas la structure ni les règles SEO.")}
            </p>

            

            

            <div
              style={{
                marginTop: '16px',
                borderRadius: '12px',
                border: '1px solid #E5E7EB',
                overflow: 'hidden',
                backgroundColor: '#FFFFFF',
              }}
            >
              <div
                style={{
                  padding: '10px 14px',
                  borderBottom: '1px solid #E5E7EB',
                  borderRight: '1px solid #E5E7EB',
                  backgroundColor: '#F9FAFB',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '4px',
                }}
              >
                <div style={{ fontSize: '13px', fontWeight: 600 }}>
                  {t('Format recommandé')}
                </div>
                <div style={{ fontSize: '12px', color: '#6B7280' }}>
                  {t('→ Utilisez une liste structurée')}
                </div>
              </div>

              <div style={{ padding: '10px 14px', fontSize: '12px', color: '#374151' }}>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Niveau de langue')}
                  </div>
                  <div className="help-panel-table-value">{t('Simple et accessible')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Relation au lecteur')}
                  </div>
                  <div className="help-panel-table-value">{t('Complice et directe')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Tutoiement')}
                  </div>
                  <div className="help-panel-table-value">{t('Obligatoire')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Rythme')}
                  </div>
                  <div className="help-panel-table-value">{t('Dynamique et engageant')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Voix')}
                  </div>
                  <div className="help-panel-table-value">{t('Active')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Posture')}
                  </div>
                  <div className="help-panel-table-value">{t('Centrée sur le spectateur et l\'expérience vécue')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Objectif')}
                  </div>
                  <div className="help-panel-table-value">{t('Donner envie de découvrir et de sortir')}</div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Style')}
                  </div>
                  <div className="help-panel-table-value">
                    {t("Privilégier les verbes d'action et les bénéfices concrets")}
                  </div>
                </div>
                <div className="help-panel-table-row">
                  <div className="help-panel-table-label">
                    {t('Clarté')}
                  </div>
                  <div className="help-panel-table-value">
                    {t('Éviter toute phrase générique, élitiste ou trop promotionnelle')}
                  </div>
                </div>
              </div>

            </div>

            <div
                style={{
                  padding: '6px 14px 10px',
                  fontSize: '11px',
                  color: '#9CA3AF',
            
                }}
              >
                {t('Vous pouvez vous inspirer de cet exemple pour structurer votre champ.')}
              </div>
          </>
        );
        case 'interditExpressions':
          return (
            <>
              <h5 className="help-panel-section-title">{t('Expressions interdites')}</h5>
              <p
                style={{
                  backgroundColor: '#F1F1F1',
                  color: '#818181',
                  padding: '8px 8px 8px 36px',
                  borderRadius: '8px',
                  position: 'relative',
                  marginBottom: '12px',
                }}
              >
                {t("🎯 Ce champ permet d'indiquer des mots ou expressions à éviter dans le texte final.")}
              </p> 
              <div
                style={{
                  marginTop: '16px',
                  borderRadius: '12px',
                  border: '1px solid #E5E7EB',
                  overflow: 'hidden',
                  backgroundColor: '#F1F1F1',
                }}
              >
                <div
                  style={{
                    padding: '10px 14px',
                    borderBottom: '1px solid #E5E7EB',
                    backgroundColor: '#FDFDFC',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  <div style={{ fontSize: '12px', fontWeight: 400, color: '#1A1A1A', marginLeft: '10px' }}>
                    <img src="/Images/icon-inter.png" alt="" className="help-panel-product-icon" style={{ width: '24px', height: '24px', flexShrink: 0, marginRight: '10px' }} />
                    {t('Renseignez uniquement des mots ou expressions courtes')}
                  </div>
                </div>

                <div
                  style={{
                    padding: '10px 14px',
                    borderTop: '1px solid #E5E7EB',
                    fontSize: '12px',
                    color: '#374151',    
                    borderBottom: '1px solid #E5E7EB',
                    borderRadius: '0 0 12px 12px',
                    backgroundColor: '#FDFDFC',
                  }}
                >
                  <div style={{ fontSize: '11px', fontWeight: 600, color: '#6B7280', marginBottom: '6px' }}>
                    {t('EXEMPLES ILLUSTRATIFS :')}
                  </div>
                  <div style={{ color: '#4B5563', lineHeight: 1.8 }}>
                    {t('En conclusion')}<br />
                    {t('Dans cet article')}<br />
                    {t('Cliquez ici')}<br />
                    {t('Meilleur du marché')}<br />
                    {t('Révolutionnaire')}<br />
                    {t('Incroyable opportunité')}
                  </div>
                </div>

                <div
                  style={{
                    padding: '8px 14px',
                    fontSize: '11px',
                    color: '#6B7280',
                    backgroundColor: '#F3F4F6',
                    borderRadius: '0 0 12px 12px',
                  }}
                >
                  {t('Saisissez vos propres expressions')}<br />
                  {t('Ces exemples ne sont pas des règles imposées.')}
                </div>
              </div>
            </>
          );
      default:
        return null;
    }
    
  };

  return (
    <div className={`help-panel-inline ${open ? 'open' : ''}`}>
      <div className="help-panel">
        <div className="help-panel-header">
          <div className="help-panel-title">{t('Aide à création')}</div>
          <button type="button" className="help-panel-close" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="help-panel-body">
          {renderContent()}
        </div>
      </div>
    </div>
  );
}

export default HelpPanel;